import { IPublicationsReportRecord } from "../../../model/report/PublicationsReportRecord";
import PublicationsReportReportingPeriodPresentationModel, {
  TPublicationsReportReportingPeriodPresentationModel
} from "./PublicationsReportReportingPeriodPresentationModel";

export interface TPublicationsReportApplicantPresentationModel {
  applicantId: number;
  partyId: number;
  name: string;
  surname: string;
  fatherName: string;
  maidenName: string;
  reportingPeriods: TPublicationsReportReportingPeriodPresentationModel[];
  fullname: string;
}

const getReportingPeriods = (
  publicationsReportRecords: IPublicationsReportRecord[]
) => {
  let reportingPeriodIds = publicationsReportRecords.map(
    (publicationsReportRecord: IPublicationsReportRecord) =>
      publicationsReportRecord.reportingPeriodId
  );

  reportingPeriodIds = reportingPeriodIds.filter((id, index, self) => {
    return self.indexOf(id) === index;
  });

  let reportingPeriods = [] as IPublicationsReportRecord[][];

  reportingPeriodIds.forEach((id: number) => {
    let reportRecords = publicationsReportRecords.filter(
      (publicationsReportRecord: IPublicationsReportRecord) => {
        return publicationsReportRecord.reportingPeriodId === id;
      }
    );
    reportingPeriods.push(reportRecords);
  });

  return reportingPeriods;
};

const PublicationsReportApplicantPresentationModel = (
  publicationReportRecords: IPublicationsReportRecord[]
): TPublicationsReportApplicantPresentationModel => {
  let applicant = {} as TPublicationsReportApplicantPresentationModel;

  if (publicationReportRecords && publicationReportRecords.length > 0) {
    applicant = {
      applicantId: publicationReportRecords[0].applicantId,
      partyId: publicationReportRecords[0].partyId,
      name: publicationReportRecords[0].name,
      surname: publicationReportRecords[0].surname,
      fatherName: publicationReportRecords[0].fatherName,
      maidenName: publicationReportRecords[0].maidenName,
      fullname: `${publicationReportRecords[0].name} ${publicationReportRecords[0].surname}`,

      reportingPeriods: [] as TPublicationsReportReportingPeriodPresentationModel[]
    };

    let reportingPeriods = getReportingPeriods(publicationReportRecords);

    applicant.reportingPeriods = reportingPeriods.map((reportingPeriod) => {
      return PublicationsReportReportingPeriodPresentationModel(
        reportingPeriod
      );
    });
  }
  return applicant;
};

export default PublicationsReportApplicantPresentationModel;
